import { ref, computed, onMounted, onUnmounted } from 'vue'

/** Largeur en dessous de laquelle on bascule en mode compact (mini softphone).
 *  Choisie pour que le PhonePanel (~300 px) + un peu de chrome tienne sans
 *  scroll horizontal. */
const COMPACT_BREAKPOINT = 560

/** État partagé entre toutes les vues — un seul listener global, et tous les
 *  consommateurs lisent la même valeur réactive. */
const windowWidth = ref(
  typeof window !== 'undefined' ? window.innerWidth : 1024,
)
let listenerInstalled = false
let detached = ref(false)

function installListener() {
  if (listenerInstalled || typeof window === 'undefined') return
  listenerInstalled = true
  const handler = () => {
    windowWidth.value = window.innerWidth
  }
  window.addEventListener('resize', handler, { passive: true })
}

/**
 * `useCompactMode` — détecte si l'app doit afficher le mini-softphone.
 *
 * Le mode compact s'active automatiquement quand la fenêtre Electron est
 * inférieure à `COMPACT_BREAKPOINT` (typiquement quand l'utilisateur a
 * cliqué le bouton "détacher" qui réduit la fenêtre). On expose aussi le
 * flag `detached` côté UI pour ajuster les contrôles (bouton "agrandir"
 * visible uniquement quand on est en mini).
 */
export function useCompactMode() {
  onMounted(() => installListener())
  onUnmounted(() => {
    /* listener global, on ne le retire pas */
  })

  const isCompact = computed(() => windowWidth.value < COMPACT_BREAKPOINT)

  return {
    isCompact,
    detached,
    width: windowWidth,
  }
}
